import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_NOTIFICATION_CC_BCC_MASS_MAILING_INFO,
} from '../EmailCreationForm.constants'
import { isEmailFormNoEmptyCcBccRecipients } from '../EmailCreationForm.utils'

export function useMassMailingCcBccNotification({
  mass,
  removeNotification,
  setNotification,
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  useEffect(() => {
    if (mass && isEmailFormNoEmptyCcBccRecipients(values)) {
      setNotification({
        id: EMAIL_CREATION_FORM_NOTIFICATION_CC_BCC_MASS_MAILING_INFO,
        text: t('Form.EmailMassMailingCcBccInfoKey'),
        type: NOTIFICATION_TYPE.info,
      })
    } else {
      removeNotification(
        EMAIL_CREATION_FORM_NOTIFICATION_CC_BCC_MASS_MAILING_INFO
      )
    }
  }, [
    mass,
    values[EMAIL_CREATION_FORM_FIELD_NAME_BCC],
    values[EMAIL_CREATION_FORM_FIELD_NAME_CC],
  ])
}
